import Service from './service';

export default class ProductService extends Service {
  baseApi = '/products';

  async getProducts(query) {
    const url = `${this.baseApi}`;
    return await this.getResource(url, query);
  }

  async updateProduct(id, body) {
    const url = `${this.baseApi}/${id}`;
    return await this.putResource(url, body);
  }

  async createProduct(body) {
    const url = `${this.baseApi}`;
    return await this.postResource(url, body);
  }
}
